<div class="h-screen flex flex-col overflow-hidden font-inter">
  <div class="flex flex-1 min-h-0 relative overflow-hidden">
    <app-sidebar
      (openCloseShiftEmit)="showCloseShiftDialog = $event"
      (openStartShiftEmit)="showOpenShiftDialog = $event"
      (openDeactivationEmit)="showDeactivationModal()"
    ></app-sidebar>

    <div class="flex-1 min-h-0 overflow-hidden">
      <router-outlet />
    </div>
  </div>
  <app-footer></app-footer>
</div>

<p-toast [baseZIndex]="toastBaseZIndex"></p-toast>

<app-deactivation-modal #deactivationModal></app-deactivation-modal>

<p-dialog
  [header]="'shift.open_dialog_title' | translate"
  [(visible)]="showOpenShiftDialog"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="false"
  [style]="{ width: '450px' }"
  [closeOnEscape]="false"
  appendTo="body"
  (onHide)="initialCashAmount.setValue(0)"
>
  <div class="flex flex-col gap-4 p-4">
    <div
      class="flex items-center gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg"
    >
      <i class="pi pi-info-circle text-blue-600 text-xl"></i>
      <div class="text-sm text-blue-800">
        <p class="font-medium mb-1">{{ 'shift.init_new_shift' | translate }}</p>
        <p>{{ 'shift.enter_opening_cash' | translate }}</p>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label for="initialCash" class="text-sm font-medium text-gray-700">
        {{ 'shift.initial_cash_label' | translate }} <span class="text-red-500">*</span>
      </label>
      <div class="flex items-center gap-2">
        <i class="pi pi-money-bill text-green-600"></i>
        <p-inputNumber
          id="initialCash"
          [formControl]="initialCashAmount"
          mode="currency"
          currency="VND"
          locale="vi-VN"
          [min]="0"
          [max]="100000000"
          [placeholder]="'shift.initial_cash_placeholder' | translate"
          styleClass="w-full"
          [useGrouping]="true"
        >
        </p-inputNumber>
      </div>
      <small class="text-gray-500">
        {{ 'shift.initial_cash_hint' | translate }}
      </small>
    </div>

    <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
      <div class="flex items-center gap-2 text-yellow-800">
        <i class="pi pi-exclamation-triangle"></i>
        <span class="text-sm font-medium">{{ 'shift.important_note' | translate }}</span>
      </div>
      <ul class="text-sm text-yellow-700 mt-2 ml-4 space-y-1">
        <li>
          • {{ 'shift.note_match_drawer' | translate }}
        </li>
        <li>• {{ 'shift.note_reconcile' | translate }}</li>
        <li>• {{ 'shift.note_cannot_change' | translate }}</li>
      </ul>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <p-button
        [label]="'common.cancel' | translate"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="cancelOpenShift()"
      >
      </p-button>
      <p-button
        [label]="'shift.open_confirm' | translate"
        icon="pi pi-check"
        severity="success"
        [disabled]="(initialCashAmount.value ?? 0) <= 0"
        (onClick)="confirmOpenShift()"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="'shift.close_dialog_title' | translate"
  [(visible)]="showCloseShiftDialog"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  appendTo="body"
  (onHide)="endCashAmount.setValue(0)"
  [dismissableMask]="false"
>
  <div class="flex flex-col gap-4 p-2">
    <!-- Summary Section -->
    <div class="grid grid-cols-3 gap-4">
      <!-- Left Column - Shift Info -->
      <div class="col-span-1 flex flex-col gap-4">
        <div class="p-4 rounded border border-blue-200 bg-blue-50">
          <div class="flex items-center gap-2 mb-3">
            <i class="pi pi-info-circle text-blue-600"></i>
            <span class="font-semibold text-blue-800"
              >{{ 'shift.shift_info_title' | translate }}</span
            >
          </div>
          <div class="grid gap-2 text-sm">
            <div class="flex justify-between">
              <span class="text-neutral-600 w-40">{{ 'shift.store_label' | translate }}</span>
              <strong class="text-right">{{
                (closeShiftOrderSummary | async)?.channelName
              }}</strong>
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-600 w-40">{{ 'shift.address_label' | translate }}</span>
              <strong class="text-right">{{
                (closeShiftOrderSummary | async)?.channelAddress
              }}</strong>
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-600 w-40">{{ 'shift.pos_terminal_label' | translate }}</span>
              <strong class="text-right">{{
                (closeShiftOrderSummary | async)?.posName
              }}</strong>
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-600 w-40">{{ 'shift.started_at' | translate }}</span>
              <strong class="text-right">{{
                (closeShiftOrderSummary | async)?.startTime
                  | date: "HH:mm - dd/MM/yyyy"
              }}</strong>
            </div>
          </div>
        </div>

        <div class="p-4 rounded border border-green-200 bg-green-50">
          <div class="flex items-center gap-2 mb-3">
            <i class="pi pi-money-bill text-green-600"></i>
            <span class="font-semibold text-green-800">{{ 'shift.cash_overview_title' | translate }}</span>
          </div>
          <div class="grid gap-2 text-sm">
            <div class="flex justify-between">
              <span class="text-neutral-600">{{ 'shift.start_cash' | translate }}</span>
              <strong class="text-green-700">{{
                (closeShiftOrderSummary | async)?.startCash
                  | currency: "VND" : "symbol" : "1.0-0" : "vi"
              }}</strong>
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-600">{{ 'shift.total_cash_revenue' | translate }}</span>
              <strong class="text-green-700">
                {{
                  getPaymentMethodTotal("CASH")
                    | currency: "VND" : "symbol" : "1.0-0" : "vi"
                }}</strong
              >
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-600">{{ 'shift.total_refund' | translate }}</span>
              <strong class="text-red-700">
                {{
                  getTotalRefund() | currency: "VND" : "symbol" : "1.0-0" : "vi"
                }}
              </strong>
            </div>
            <!-- <div class="flex justify-between">
                            <span class="text-neutral-600">{{ 'o2o.stat_total_orders' | translate }} hàng:</span>
                            <strong class="text-green-700">{{ (closeShiftOrderSummary | async)?.details?.length }}</strong>
                        </div> -->
            <div class="flex justify-between pt-2 border-t border-green-300">
              <span class="text-neutral-600 font-medium"
                >{{ 'shift.expected_cash' | translate }}</span
              >
              <strong class="text-green-700 text-lg">
                {{
                  ((closeShiftOrderSummary | async)?.startCash ?? 0) +
                    getPaymentMethodTotal("CASH") -
                    getTotalRefund()
                    | currency: "VND" : "symbol" : "1.0-0" : "vi"
                }}
              </strong>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label for="endCash" class="text-sm font-medium"
            >{{ 'shift.actual_end_cash_label' | translate }} <span class="text-red-500">*</span></label
          >
          <p-inputNumber
            inputId="endCash"
            [formControl]="endCashAmount"
            mode="currency"
            currency="VND"
            locale="vi-VN"
            [min]="0"
            [useGrouping]="true"
            [placeholder]="'shift.actual_end_cash_placeholder' | translate"
            styleClass="w-full"
          >
          </p-inputNumber>
          <small class="text-gray-500">
            {{ 'shift.end_cash_hint' | translate }}
          </small>
        </div>

        <div
          class="p-3 rounded border"
          [ngClass]="{
            'bg-yellow-50 border-yellow-200': getCashDifference() !== 0,
            'bg-green-50 border-green-200': getCashDifference() === 0,
          }"
        >
          <div class="flex items-center justify-between">
            <span
              class="text-sm font-medium"
              [ngClass]="{
                'text-yellow-800': getCashDifference() !== 0,
                'text-green-800': getCashDifference() === 0,
              }"
            >
              {{ 'shift.cash_difference' | translate }}
            </span>
            <strong
              class="text-lg"
              [ngClass]="{
                'text-yellow-700': getCashDifference() !== 0,
                'text-green-700': getCashDifference() === 0,
              }"
            >
              {{
                getCashDifference()
                  | currency: "VND" : "symbol" : "1.0-0" : "vi"
              }}
            </strong>
          </div>
          <div
            class="text-xs mt-1"
            [ngClass]="{
              'text-yellow-700': getCashDifference() !== 0,
              'text-green-700': getCashDifference() === 0,
            }"
          >
            <span *ngIf="getCashDifference() > 0">{{ 'shift.cash_surplus' | translate }}</span>
            <span *ngIf="getCashDifference() < 0">{{ 'shift.cash_shortage' | translate }}</span>
            <span *ngIf="getCashDifference() === 0"
              >{{ 'shift.cash_exact' | translate }}</span
            >
          </div>
        </div>
      </div>

      <!-- Right Column - Order Details -->
      <div class="col-span-2 flex flex-col gap-3">
        <div
          class="flex items-center justify-between p-3 bg-neutral-50 rounded border border-neutral-200"
        >
          <div class="flex items-center gap-2">
            <i class="pi pi-list text-neutral-600"></i>
            <span class="font-semibold text-neutral-800"
              >{{ 'shift.orders_in_shift_title' | translate }}</span
            >
          </div>
          <p-tag
            [value]="
              (closeShiftOrderSummary | async)?.details?.length?.toString() ||
              '0'
            "
            severity="info"
          >
          </p-tag>
        </div>

        <div
          class="border border-neutral-200 rounded overflow-hidden"
          style="max-height: 500px"
        >
          <p-table
            [value]="(closeShiftOrderSummary | async)?.details || []"
            [scrollable]="true"
            scrollHeight="500px"
            styleClass="text-sm"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="min-width: 120px">{{ 'shift.col_order_code' | translate }}</th>
                <th style="min-width: 150px">{{ 'shift.col_customer' | translate }}</th>
                <th class="text-center" style="width: 80px">{{ 'shift.col_qty' | translate }}</th>
                <th class="text-right" style="width: 120px">{{ 'shift.col_total' | translate }}</th>
                <th style="width: 140px">{{ 'shift.col_payment_method' | translate }}</th>
                <th style="width: 100px">{{ 'logs.col_time' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-order>
              <tr>
                <td>
                  <div class="flex flex-col">
                    <span class="font-medium text-neutral-800"
                      >#{{ order.innerOrderNo || order.outerOrderNo || order.id }}</span
                    >
                  </div>
                </td>
                <td>
                  <div class="flex flex-col">
                    <span class="font-medium">{{ order.buyerNick }}</span>
                  </div>
                </td>
                <td class="text-center">
                  <p-tag
                    [value]="order.goodsQuatity?.toString()"
                    severity="info"
                  ></p-tag>
                </td>
                <td class="text-right">
                  <span class="font-semibold text-green-700">
                    {{
                      order.buyerRealPrice
                        | currency: "VND" : "symbol" : "1.0-0" : "vi"
                    }}
                  </span>
                </td>
                <td>
                  <p-tag
                    [value]="getPaymentMethodLabel(order.payType)"
                    [severity]="getPaymentMethodSeverity(order.payType)"
                  >
                  </p-tag>
                </td>
                <td>
                  <div class="flex flex-col text-xs">
                    <span>{{ order.orderTime | date: "HH:mm" }}</span>
                    <span class="text-neutral-500">{{
                      order.orderTime | date: "dd/MM"
                    }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">
                  <div
                    class="flex flex-col items-center justify-center py-8 text-neutral-500"
                  >
                    <i class="pi pi-inbox text-4xl mb-3"></i>
                    <div class="text-lg font-medium">{{ 'shift.no_orders_in_shift' | translate }}</div>
                    <div class="text-sm">
                      {{ 'shift.no_transactions_in_shift' | translate }}
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="bg-neutral-50 font-semibold">
                <td colspan="2" class="text-right">{{ 'shift.total_label' | translate }}</td>
                <td class="text-center">
                  {{ (closeShiftOrderSummary | async)?.totalOrderQuantity }}
                </td>
                <td class="text-right text-green-700 text-lg">
                  {{
                    (closeShiftOrderSummary | async)?.totalOrderAmount
                      | currency: "VND" : "symbol" : "1.0-0" : "vi"
                  }}
                </td>
                <td colspan="2"></td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <!-- Payment Method Summary -->
        <div class="grid grid-cols-3 gap-2">
          <div class="p-3 bg-green-50 border border-green-200 rounded">
            <div class="text-xs text-green-700 mb-1">{{ 'payment.cash' | translate }}</div>
            <div class="font-semibold text-green-800">
              {{
                getPaymentMethodTotal("CASH")
                  | currency: "VND" : "symbol" : "1.0-0" : "vi"
              }}
            </div>
          </div>
          <div class="p-3 bg-blue-50 border border-blue-200 rounded">
            <div class="text-xs text-blue-700 mb-1">{{ 'payment.card' | translate }}</div>
            <div class="font-semibold text-blue-800">
              {{
                getPaymentMethodTotal("CARD")
                  | currency: "VND" : "symbol" : "1.0-0" : "vi"
              }}
            </div>
          </div>
          <div class="p-3 bg-purple-50 border border-purple-200 rounded">
            <div class="text-xs text-purple-700 mb-1">{{ 'payment.e_wallet' | translate }}</div>
            <div class="font-semibold text-purple-800">
              {{
                getPaymentMethodTotal("E_WALLET")
                  | currency: "VND" : "symbol" : "1.0-0" : "vi"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Warning -->
    <div
      class="p-3 rounded bg-red-50 border border-red-200 text-sm text-red-700 flex items-start gap-2"
    >
      <i class="pi pi-exclamation-triangle text-red-600 mt-0.5"></i>
      <div>
        <div class="font-medium mb-1">{{ 'shift.important_note' | translate }}</div>
        <ul class="ml-4 space-y-1">
          <li>• {{ 'shift.close_note_count_cash' | translate }}</li>
          <li>• {{ 'shift.close_note_verify_orders' | translate }}</li>
          <li>• {{ 'shift.close_note_cannot_edit' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <p-button
        [label]="'common.cancel' | translate"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="cancelCloseShift()"
      >
      </p-button>
      <p-button
        [label]="'shift.close_confirm' | translate"
        icon="pi pi-check"
        severity="danger"
        (onClick)="confirmCloseShift()"
        [loading]="isShiftLoading | async"
        [disabled]="(isShiftLoading | async) || (endCashAmount.value ?? 0) <= 0"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>
